import { render, staticRenderFns } from "./VoicemailsTab.vue?vue&type=template&id=5d902a40&"
import script from "./VoicemailsTab.vue?vue&type=script&lang=js&"
export * from "./VoicemailsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports